var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24356 13.6436C8.73167 18.6065 12.7055 22.6393 17.5943 25.1641L21.3843 21.3049C21.8595 20.8221 22.5372 20.6844 23.1328 20.8767C25.0571 21.5232 27.1343 21.8742 29.2779 21.8742C30.2331 21.8742 31 22.6534 31 23.624V29.7488C31 30.7194 30.2331 31.4986 29.2779 31.4986C13.105 31.4986 0 18.1828 0 1.74982C0 0.783803 0.771696 0 1.72212 0H7.75C8.70523 0 9.47212 0.779225 9.47212 1.74982C9.47212 3.92787 9.81757 6.03846 10.4538 7.99705C10.6433 8.59894 10.5079 9.2921 10.0323 9.77495L6.24356 13.6436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.54127b2d0e2317deef39a147104e32a6.svg";
export { ForwardRef as ReactComponent };